import Vue from "vue";
import Router from "vue-router";
import Index from "@/pages/Index";
import qcjg from "@/pages/qcjg";
import Xnyqc from "@/pages/xnyqc";
import Sdwyj from "@/pages/sdwyj";
import News from "@/pages/new";
import FZLC from "@/pages/fzlc";
import ZZRZ from "@/pages/ZZRZ";
import XHPK from "@/pages/xhpk";
import Htjs from "@/pages/htjs";
import Gdjt from "@/pages/gdjt";
import Gf from "@/pages/gf";
import Contact from "@/pages/Contact";
import About from "@/pages/About";
import Product from "@/pages/Product";
import ProductDetail from "@/pages/ProductDetail";
import NewsDetail from "@/pages/NewsDetail";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      redirect: {
        name: "Index"
      }
    },
    {
      path: "/index",
      name: "Index",
      component: Index,
      meta: {
        title: "首页-Sailuk"
      }
    },
    {
      path: "/certificates",
      name: "Certificates",
      component: ZZRZ,
      meta: {
        title: "首页-Sailuk"
      }
    },
    {
      path: "/history",
      component: FZLC,
      meta: {
        title: "首页-Sailuk"
      }
    },
    {
      path: "/quality",
      component: XHPK,
      meta: {
        title: "首页-Sailuk"
      }
    },
    {
      path: "/news",
      name: "News",
      component: News,
      meta: {
        title: "首页-Sailuk"
      }
    },
    {
      path: "/index/:id",
      redirect: "/index"
    },
    {
      path: "/solution/1",
      name: "Xnyqc",
      component: Xnyqc,
      meta: {
        title: "解决方案-新能源汽车-Sailuk"
      }
    },
    {
      path: "/solution/2",
      name: "Htjs",
      component: Htjs,
      meta: {
        title: "解决方案-飞机应用-Sailuk"
      }
    },
    {
      path: "/solution/3",
      name: "Gdjt",
      component: Gdjt,
      meta: {
        title: "解决方案-高铁应用-Sailuk"
      }
    },
    {
      path: "/solution/4",
      name: "Gf",
      component: Gf,
      meta: {
        title: "解决方案-光伏产业应用-Sailuk"
      }
    },
    {
      path: "/solution/5",
      name: "Solution",
      component: qcjg,
      meta: {
        title: "解决方案-汽车应用-Sailuk"
      }
    },
    {
      path: "/solution/6",
      name: "Sdwyj",
      component: Sdwyj,
      meta: {
        title: "解决方案-射电望远镜应用-Sailuk"
      }
    },
    // {
    //   path: '/solution/:id',
    //   name: 'Solution',
    //   component: Solution,
    //   meta: {
    //     title: '解决方案-Sailuk'
    //   }
    // },
    // {
    //   path: '/solution',
    //   redirect: '/solution/1'
    // },
    {
      path: "/contact",
      name: "Contact",
      component: Contact,
      meta: {
        title: "联系我们-Sailuk"
      }
    },
    {
      path: "/about",
      name: "About",
      component: About,
      meta: {
        title: "公司介绍-Sailuk"
      }
    },
    {
      path: "/product/:id",
      name: "Product",
      component: Product,
      meta: {
        title: "产品列表-Sailuk"
      }
    },
    {
      path: "/newsDetail/:id",
      name: "newsDetail",
      component: NewsDetail,
      meta: {
        title: "新闻详情-Sailuk"
      }
    },
    {
      path: "/product",
      redirect: "/product/0"
    },
    {
      path: "/pd",
      redirect: "/pd/1"
    },
    {
      path: "/pd/:id/:name",
      name: "pd",
      component: ProductDetail,
      meta: {
        title: "产品详情-Sailuk"
      }
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js